import React from "react";

interface CityViewProps {
  className?: string;
}

export const CityViewIcon: React.FC<CityViewProps> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="8"
        y="8"
        width="14"
        height="13"
        rx="1"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect
        x="2"
        y="3"
        width="10"
        height="18"
        rx="1"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect x="14" y="11" width="1.5" height="1.5" rx="0.5" fill="currentColor" />
      <rect x="17.5" y="11" width="1.5" height="1.5" rx="0.5" fill="currentColor" />
      <rect x="14" y="14" width="1.5" height="1.5" rx="0.5" fill="currentColor" />
      <rect x="14" y="17" width="1.5" height="1.5" rx="0.5" fill="currentColor" />
      <rect x="17.5" y="14" width="1.5" height="1.5" rx="0.5" fill="currentColor" />
      <rect x="17.5" y="17" width="1.5" height="1.5" rx="0.5" fill="currentColor" />
      <path d="M2 7.5H11.5" stroke="currentColor" strokeWidth="2" />
      <path d="M2 12H11.5" stroke="currentColor" strokeWidth="2" />
      <path d="M2 16.5H11.5" stroke="currentColor" strokeWidth="2" />
      <rect x="6" y="2" width="2" height="18" fill="currentColor" />
    </svg>
  );
};
